module.exports = __webpack_public_path__ + "static/media/iconProfessorsActive.2a23b94c.svg";